// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { Baseurl } from "../../config/BaseUrl";
// import { act } from "react";

// const initialState = {
//   loading: false,
//   saloonList: [],
//   desktopimage:'',
//   mobileimage:'',
//   imageLoading:false,
//   clickedSaloon:'',
//   clickedCategory:'',
//   choosedCategory:'',
//   allCategoriesFromSaloon:[],
//   saloonCategoryLoading:false,
//   categoryChoosedBySearch:''
// };
// export const createSaloon = createAsyncThunk(
//   "saloon/createSaloon",
//   async (formData, thunkAPI) => {
//     try {
//       const config = {
//         headers: { "Content-Type": "application/json" },
//         maxBodyLength: Infinity,
//       };
//       const url = `${Baseurl}/api/v1/saloon/new`;
//       const resp = await axios.post(url, formData, config);
//       console.log(resp.data, "resp.data");
//       return resp.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );
// export const getSaloonList = createAsyncThunk(
//   "saloon/saloonList",
//   async (thunkAPI) => {
//     try {
//       const url = `${Baseurl}/api/v1/saloon/all`;
//       const resp = await axios.get(url);
//       console.log(resp.data, "resp.data");
//       return resp.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );
// export const getAllCategoriesBySaloon=createAsyncThunk(
//   "saloon/getAllCategoriesBySaloon",
//   async(thunkAPI)=>{
//     try{
//     const url = `${Baseurl}/api/v1/saloonCategory/all`;
//     const resp = await axios.get(url);
//     console.log(resp.data, "resp.data");
//     return resp.data;
//   }catch(error){
//     return thunkAPI.rejectWithValue(error.response.data);
//   }
//   }
// )
// export const getSaloonMadeFor=createAsyncThunk(
//   "saloon/saloonMadeFor",
//   async(formData,thunkAPI)=>{
//     try {
//       const url = `${Baseurl}/api/v1/saloon/saloonfor/${formData.name}`;
//       const resp = await axios.get(url);
//       console.log(resp.data, "resp.data");
//       return resp.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// )
// export const getSaloonById=createAsyncThunk(
//     "saloon/sallonById",
//     async(formData,thunkAPI)=>{
//         try{
//             const url=`${Baseurl}/api/v1/saloon/singleSaloon/${formData}`;
//             console.log(url,'url');
//             const resp=await axios.get(url);
//             console.log(resp.data,"resp.data");
//             return resp.data;
//         }catch(error){
//             return thunkAPI.rejectWithValue(error.response.data);
//         }
//     }
// )
// export const serviceImages = createAsyncThunk(
//     "brand/serviceImages",
//     async (formData, thunkAPI) => {
//       try {
//         const config = {
//           Headers: { "Content-Type": "application/json" },
//           maxBodyLength: Infinity,
//         };
//         const url = `${Baseurl}/api/v1/saloon/saloonImage`;
//         const resp = await axios.post(url, formData, config);
//         return resp.data;
//       } catch (error) {
//         return thunkAPI.rejectWithValue("brandimages Not create");
//       }
//     }
//   );
// export const validateSlugUrl = createAsyncThunk(
//     "saloon/validateSlugUrl",
//     async (slugUrl , thunkAPI) => {
//       let resp = {
//         success: false,
//         message: "new name",
//       }
//       try {
//         const url = `${Baseurl}/api/v1/saloon/slugUrl/${slugUrl}`;
//         const resp = await axios.get(url);
//         return resp.data;
//       } catch (error) {
//         return error;
//       }
//     }
//   );

// export const updateSaloon = createAsyncThunk(
//   "saloon/updateSaloon",
//   async (formData, thunkAPI) => {
//     try {
//       const config = {
//         headers: { "Content-Type": "application/json" },
//       };
//       const url = `${Baseurl}/api/v1/saloon/update/${formData._id}`;
//       const resp = await axios.put(url, formData, config);
//       console.log(resp.data, "resp.data");
//       return resp.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );
// export const updateSaloonService = createAsyncThunk(
//   "saloon/updateSaloonService",
//   async (formData, thunkAPI) => {
//     try {
//       const config = {
//         headers: { "Content-Type": "application/json" },
//       };
//       const url = `${Baseurl}/api/v1/saloon/updateService/${formData._id}`;
//       console.log(url,'url');
//       const resp = await axios.put(url, formData, config);
//       console.log(resp.data, "resp.data");
//       return resp.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );
// export const deleteSaloon = createAsyncThunk(
//   "saloon/deleteSaloon",
//   async (formData, thunkAPI) => {
//     try {
//       const url = `${Baseurl}/api/v1/saloon/delete/${formData._id}`;
//       const resp = await axios.delete(url);
//       console.log(resp.data, "resp.data");
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

// const saloonSlice = createSlice({
//   name: "saloon",
//   initialState: initialState,
//   reducers: {
//     setSelectedSaloon:(state,action)=>{
//       console.log(action.payload,'action.payload');
//       state.clickedSaloon = action.payload
//     },
//     setSearchCategory:(state,action)=>{
//       state.categoryChoosedBySearch=action.payload
//     },
//     setClickedCategory:(state,action)=>{
//       console.log(action.payload,'action.setClickedCategory');
//       state.clickedCategory = action.payload
//     },
//     setChoosedCategory:(state,action)=>{
//       console.log(action.payload,'action.setClickedCategory');
//       state.choosedCategory = action.payload
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(createSaloon.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(createSaloon.fulfilled, (state, action) => {
//         state.loading = false;
//         state.saloonList = [action?.payload?.saloon, ...state.saloonList];
//       })
//       .addCase(createSaloon.rejected, (state) => {
//         state.loading = true;
//       })
//       .addCase(serviceImages.pending, (state) => {
//         state.imageLoading = true;
//       })
//       .addCase(serviceImages.fulfilled, (state, action) => {
//         state.imageLoading = false;
//         state.mobileimage = action.payload.mobileimages;
//         state.desktopimage = action.payload.desktopImages;
//       })
//       .addCase(serviceImages.rejected, (state) => {
//         state.imageLoading = true;
//       })
//       .addCase(getSaloonList.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(getSaloonList.fulfilled, (state, action) => {
//         state.loading = false;
//         state.saloonList = [...action?.payload?.saloon];
//       })
//       .addCase(getSaloonList.rejected, (state) => {
//         state.loading = true;
//       })
//       .addCase(getAllCategoriesBySaloon.pending, (state) => {
//         state.saloonCategoryLoading = true;
//       })
//       .addCase(getAllCategoriesBySaloon.fulfilled, (state, action) => {
//         state.saloonCategoryLoading = false;
//         state.allCategoriesFromSaloon = [...action.payload.category];
//       })
//       .addCase(getAllCategoriesBySaloon.rejected, (state) => {
//         state.saloonCategoryLoading = true;
//       })
//       .addCase(updateSaloon.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(updateSaloon.fulfilled, (state, action) => {
//           if(action.payload.success){
//             state.loading = false;
//             state.saloonList = state.saloonList.filter((individualSaloon)=>
//                 individualSaloon._id!==action?.payload?.saloon._id
//             )
//             state.saloonList = [action?.payload?.saloon, ...state.saloonList];
//         }
//       })
//       .addCase(updateSaloon.rejected, (state) => {
//         state.loading = true;
//       })
//       .addCase(updateSaloonService.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(updateSaloonService.fulfilled, (state, action) => {
//           if(action.payload.success){
//             state.loading = false;
//             state.saloonList = state.saloonList.filter((individualSaloon)=>
//                 individualSaloon._id!==action?.payload?.saloon._id
//             )
//             state.saloonList = [action?.payload?.saloon, ...state.saloonList];
//         }
//       })
//       .addCase(updateSaloonService.rejected, (state) => {
//         state.loading = true;
//       })
//       .addCase(deleteSaloon.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(deleteSaloon.fulfilled, (state, action) => {
//           if(action.payload.success){
//             state.loading = false;
//             state.saloonList = state.saloonList.filter((individualSaloon)=>
//                 individualSaloon._id!==action?.payload?.saloon._id
//             )
//         }
//       })
//       .addCase(deleteSaloon.rejected, (state) => {
//         state.loading = true;
//       });
//   },
// });
// export const {setSelectedSaloon,setChoosedCategory,setClickedCategory,setSearchCategory
// } = saloonSlice.actions;
// export default saloonSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";

const initialState = {
  loading: false,
  saloonList: [],
  desktopimage: "",
  mobileimage: "",
  imageLoading: false,
  clickedSaloon: "",
  clickedCategory: "",
  choosedCategory: "",
  allCategoriesFromSaloon: [],
  saloonCategoryLoading: false,
  categoryChoosedBySearch: "",
};

// CREATE SALOON
export const createSaloon = createAsyncThunk(
  "saloon/createSaloon",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
        maxBodyLength: Infinity,
      };
      const resp = await axios.post(
        `${Baseurl}/api/v1/saloon/new`,
        formData,
        config
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// GET SALOON LIST
export const getSaloonList = createAsyncThunk(
  "saloon/saloonList",
  async (_, thunkAPI) => {
    try {
      const resp = await axios.get(`${Baseurl}/api/v1/saloon/all`);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// GET ALL CATEGORIES BY SALOON
export const getAllCategoriesBySaloon = createAsyncThunk(
  "saloon/getAllCategoriesBySaloon",
  async (_, thunkAPI) => {
    try {
      const resp = await axios.get(`${Baseurl}/api/v1/saloonCategory/all`);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// GET SALOON MADE FOR
export const getSaloonMadeFor = createAsyncThunk(
  "saloon/saloonMadeFor",
  async (formData, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${Baseurl}/api/v1/saloon/saloonfor/${formData.name}`
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// GET SALOON BY ID
export const getSaloonById = createAsyncThunk(
  "saloon/sallonById",
  async (id, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${Baseurl}/api/v1/saloon/singleSaloon/${id}`
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// SERVICE IMAGES
export const serviceImages = createAsyncThunk(
  "brand/serviceImages",
  async (formData, thunkAPI) => {
    try {
      const resp = await axios.post(
        `${Baseurl}/api/v1/saloon/saloonImage`,
        formData
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("brandimages Not create");
    }
  }
);

// VALIDATE SLUG URL
export const validateSlugUrl = createAsyncThunk(
  "saloon/validateSlugUrl",
  async (slugUrl, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${Baseurl}/api/v1/saloon/slugUrl/${slugUrl}`
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// UPDATE SALOON
export const updateSaloon = createAsyncThunk(
  "saloon/updateSaloon",
  async (formData, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${Baseurl}/api/v1/saloon/update/${formData._id}`,
        formData
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// UPDATE SALOON SERVICE
export const updateSaloonService = createAsyncThunk(
  "saloon/updateSaloonService",
  async (formData, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${Baseurl}/api/v1/saloon/updateService/${formData._id}`,
        formData
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// DELETE SALOON (FIX: Added return)
export const deleteSaloon = createAsyncThunk(
  "saloon/deleteSaloon",
  async (formData, thunkAPI) => {
    try {
      const resp = await axios.delete(
        `${Baseurl}/api/v1/saloon/delete/${formData._id}`
      );
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const saloonSlice = createSlice({
  name: "saloon",
  initialState,
  reducers: {
    setSelectedSaloon: (state, action) => {
      state.clickedSaloon = action.payload;
    },
    setSearchCategory: (state, action) => {
      state.categoryChoosedBySearch = action.payload;
    },
    setClickedCategory: (state, action) => {
      state.clickedCategory = action.payload;
    },
    setChoosedCategory: (state, action) => {
      state.choosedCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE SALOON
      .addCase(createSaloon.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.saloon) {
          state.saloonList = [action.payload.saloon, ...state.saloonList];
        }
      })

      // GET SALOON LIST
      .addCase(getSaloonList.fulfilled, (state, action) => {
        state.loading = false;
        state.saloonList = Array.isArray(action.payload?.saloon)
          ? [...action.payload.saloon]
          : [];
      })

      // GET ALL CATEGORIES BY SALOON
      .addCase(getAllCategoriesBySaloon.fulfilled, (state, action) => {
        state.saloonCategoryLoading = false;
        state.allCategoriesFromSaloon = Array.isArray(action.payload?.category)
          ? [...action.payload.category]
          : [];
      })

      // UPDATE SALOON
      .addCase(updateSaloon.fulfilled, (state, action) => {
        if (action.payload?.success && action.payload?.saloon) {
          state.loading = false;
          state.saloonList = state.saloonList.filter(
            (item) => item._id !== action.payload.saloon._id
          );
          state.saloonList.unshift(action.payload.saloon);
        }
      })

      // UPDATE SALOON SERVICE
      .addCase(updateSaloonService.fulfilled, (state, action) => {
        if (action.payload?.success && action.payload?.saloon) {
          state.loading = false;
          state.saloonList = state.saloonList.filter(
            (item) => item._id !== action.payload.saloon._id
          );
          state.saloonList.unshift(action.payload.saloon);
        }
      })

      // DELETE SALOON
      .addCase(deleteSaloon.fulfilled, (state, action) => {
        if (action.payload?.success && action.payload?.saloon?._id) {
          state.saloonList = state.saloonList.filter(
            (item) => item._id !== action.payload.saloon._id
          );
        }
      })

      // SERVICE IMAGES
      .addCase(serviceImages.fulfilled, (state, action) => {
        state.imageLoading = false;
        state.mobileimage = action.payload?.mobileimages || "";
        state.desktopimage = action.payload?.desktopImages || "";
      });
  },
});

export const {
  setSelectedSaloon,
  setChoosedCategory,
  setClickedCategory,
  setSearchCategory,
} = saloonSlice.actions;

export default saloonSlice.reducer;
